import { dollarsToSatoshis } from "../../utils";
import { productPricingRowFromService, productPricingRowToService } from "./shared";
/**
 * Converts service advertiser list item to UI format.
 * List items don't have billing info.
 * @param item - Service advertiser pricing list item
 * @returns UI-formatted advertiser (no billingInfo)
 */
export const pricingAdvertiserFromService = (item) => {
    return {
        id: item.id,
        name: item.name,
        agencies: item.agencies ?? [],
        productsPriced: item.products_priced,
        productsTotal: item.products_total
    };
};
/**
 * Converts service advertiser detail to UI format.
 * Unflattens: service flat structure → UI nested billingInfo.
 * The detail lists every product the org can see, so the priced and total
 * counts are derived from it.
 * @param advertiser - Service advertiser billing info (flat)
 * @returns UI-formatted advertiser with nested billingInfo
 */
export const pricingAdvertiserBillingInfoFromService = (advertiser) => {
    const products = advertiser.products?.map(productPricingRowFromService);
    return {
        id: advertiser.advertiser_id,
        name: advertiser.name,
        agencies: advertiser.agencies ?? [],
        productsPriced: products?.filter((p) => p.cpm != null).length ?? 0,
        productsTotal: products?.length ?? 0,
        billingInfo: {
            products
        }
    };
};
/**
 * Converts UI advertiser to service format.
 * Flattens: UI nested billingInfo → service flat structure.
 * @param advertiser - UI advertiser with nested billingInfo
 * @returns Service-formatted advertiser (flat)
 */
export const pricingAdvertiserBillingInfoToService = (advertiser) => {
    return {
        advertiser_id: advertiser.id,
        name: advertiser.name,
        agencies: advertiser.agencies,
        products: advertiser.billingInfo?.products?.map(productPricingRowToService)
    };
};
/**
 * Converts advertiser to service upsert advertiser CPM request.
 * Expects billingInfo.products to hold only the changed rows; a row without a
 * cpm is sent as 0, which deletes the advertiser rate.
 * @param advertiser - Advertiser with the changed product rows
 * @returns Service-formatted upsert request
 */
export const upsertAdvertiserCpmRequestToService = (advertiser) => {
    const products = advertiser.billingInfo?.products ?? [];
    return {
        upserts: products
            .filter((p) => !!p.id)
            .map((p) => ({
            prod_id: p.id,
            advertiser_id: advertiser.id,
            cpm: dollarsToSatoshis(p.cpm)
        }))
    };
};
//# sourceMappingURL=advertisers.js.map